const CONTACT = "/api/contact";

const exportedObject = {
  CONTACT
};

export default exportedObject;
